export const ParallelRouterSymbol = Symbol("ParallelRouterSymbol");
export const ParallelRouteNotFoundSymbol = Symbol("ParallelRouteNotFoundSymbol");
